import axios from "../axiosInstance";
import { RequestMagicLinkRequest, RequestMagicLinkResponse } from "./types";

export const requestMagicLink = async (
  payload: RequestMagicLinkRequest,
): Promise<RequestMagicLinkResponse> => {
  const response = await axios.post<RequestMagicLinkResponse>(
    "/api/public/magic-link",
    payload,
  );
  return response.data;
};
